import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Pagination, Container } from 'react-bootstrap';

const AdminTourViaVideoChatPage = () => {
    const [tourOnVideoChats, setTourOnVideoChats] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);  // Number of items per page

    // Fetch TourViaVideoChat Data
    useEffect(() => {
        const fetchTourOnVideoChats = async () => {
            try {
                const response = await axios.get('https://api.biznetusa.com/api/get-touronvideochat');
                if (response.data.status === 200) {
                    // Sorting data to show latest on top
                    const sortedData = response.data.tour_on_video_chat.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                    setTourOnVideoChats(sortedData);
                }
            } catch (error) {
                console.error('Error fetching data', error);
            }
        };
        fetchTourOnVideoChats();
    }, []);

    // Get current items for pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = tourOnVideoChats.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Pagination logic
    const totalPages = Math.ceil(tourOnVideoChats.length / itemsPerPage);

    return (
        <Container className="mt-5">
            <h2>Tour Via Video Chat Requests</h2>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Backup Date</th>
                        <th>Backup Time</th>
                        <th>Preferred Video Chat App</th>
                        <th>Join Us Through</th>
                        <th>ID/Number</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Phone</th>
                        <th>Notes</th>
                        <th>Working as Real Estate Agent</th>
                        <th>Agreement to Work with Agent</th>
                    </tr>
                </thead>
                <tbody>
                    {currentItems.length > 0 ? (
                        currentItems.map((item) => (
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.date}</td>
                                <td>{item.time}</td>
                                <td>{item.backup_date}</td>
                                <td>{item.backup_time}</td>
                                <td>{item.prefer_video_chat_app}</td>
                                <td>{item.join_us_through}</td>
                                <td>{item.id_or_number}</td>
                                <td>{item.firstname}</td>
                                <td>{item.lastname}</td>
                                <td>{item.phone}</td>
                                <td>{item.notes ? item.notes : 'N/A'}</td>
                                <td>{item.working_as_realstate_agent ? 'Yes' : 'No'}</td>
                                <td>{item.agreement_committing_to_work_with_agent ? 'Yes' : 'No'}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="14">No Data Available</td>
                        </tr>
                    )}
                </tbody>
            </Table>

            {/* Pagination */}
            <Pagination>
                {[...Array(totalPages).keys()].map((number) => (
                    <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => paginate(number + 1)}>
                        {number + 1}
                    </Pagination.Item>
                ))}
            </Pagination>
        </Container>
    );
};

export default AdminTourViaVideoChatPage;
